<aeg-datatable :value="logs" :loading="isLoading">
    <template #empty>
        Er zijn geen wijzigingen gevonden voor deze actor.
    </template>
    <Column header="Aangemaakt" :field="(log) => formatDateTime(log.auditDate)" />
    <Column header="Service" field="athumiService" />
    <Column header="Aanpassing">
        <template #body="slotProps">
            <pre>{{ formatChanges(slotProps?.data?.changes) }}</pre>
        </template>
    </Column>
</aeg-datatable>

